import { render, staticRenderFns } from "./StorageClass.vue?vue&type=template&id=64ce863a&"
import script from "./StorageClass.vue?vue&type=script&lang=js&"
export * from "./StorageClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports